import { AxiosPromise } from 'axios';
import { axios } from 'libs';
import { TotalizacaoProcessoDTO, TotalizacaoProcessoForm } from 'types';

const resource = '/totalizacao-processos';

export const findAll = (
  values: TotalizacaoProcessoForm
): AxiosPromise<TotalizacaoProcessoDTO> => {
  return axios.post(`${resource}`, values);
};

export const print = (values: TotalizacaoProcessoForm) => {
  return axios
    .post(`${resource}/print`, values, {
      responseType: 'blob'
    })
    .then(response =>
      Promise.resolve(response.data)
        .then(file => URL.createObjectURL(file))
        .then(fileURL => window.open(fileURL, '_blank'))
    );
};
